module.exports = __webpack_public_path__ + "img/pink-pumpkin.a6b63f9b.png";